import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('student-ui');

export const selectCurrentStudentClassroomAction = actionCreator<string>(
  'SELECT_CURRENT_STUDENT_CLASS'
);
